import { RouteLocationNormalized } from 'vue-router';

import { pendingConsentAnswer } from '@/services/microsoftCapabilities';

/* ------------------------------------------------------------
 * Microsoft sends the admin back to the app root with its own query string, which
 * has to go: left there, it replays the consent on every reload, and its `error`
 * reads to `isRedirectCallback` as an MSAL callback, skipping account setup for the
 * rest of the session.
 *
 * It is dropped here rather than at capture time because the router snapshots the
 * location when it is created -- before the app mounts -- and `redirectRootGuard`
 * carries the whole query over to /chat.
 * ------------------------------------------------------------ */

const CONSENT_PARAMS = [
    'admin_consent',
    'tenant',
    'state',
    'scope',
    'error',
    'error_description'
];

export default function microsoftConsentGuard(to: RouteLocationNormalized) {
    // Both are needed: the parameters say there is still something to strip, and without
    // that the guard would keep redirecting to a location it has already reached, since the
    // answer outlives this navigation. The answer says the parameters are ours -- a refusal
    // carries no `admin_consent`, and `state` or `error` alone belong to other callbacks.
    const carriesAnswer = CONSENT_PARAMS.some((key) => key in to.query);
    if (!carriesAnswer || !pendingConsentAnswer()) return true;

    const query = { ...to.query };
    for (const key of CONSENT_PARAMS) delete query[key];

    return { path: to.path, query: { ...query, settingsTab: 'connections' } };
}
